
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeSmallcraftFilled as ObiVesselTypeSmallcraftFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-smallcraft-filled.js';
 
 
 

 
 export const ObiVesselTypeSmallcraftFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-smallcraft-filled',
   elementClass: ObiVesselTypeSmallcraftFilledElement,
   events: {
     
   }
  });
 
 